export const LOGIN_REQUESTED = 'LOGIN_REQUESTED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SUBSCRIPTIONS_FETCH_REQUESTED = 'SUBSCRIPTIONS_FETCH_REQUESTED'
export const SUBSCRIPTIONS_FETCH_SUCCESS = 'SUBSCRIPTIONS_FETCH_SUCCESS'
export const CREDIT_CARD_VALID_FETCH_REQUETED = 'CREDIT_CARD_VALID_FETCH_REQUETED'
export const CREDIT_CARD_VALID_FETCH_SUCCESS = 'CREDIT_CARD_VALID_FETCH_SUCCESS'
export const UNPAID_INVOICES_FETCH_REQUETED = 'UNPAID_INVOICES_FETCH_REQUETED'
export const UNPAID_INVOICES_FETCH_SUCCESS = 'UNPAID_INVOICES_FETCH_SUCCESS'
